export default {"src":"https://cdn.jetlend.ru/_next/static/media/double-arrow-left.6b813556.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};